/* Mobile only: move existing blocks, retaining native forms and DOM/tab order. */
(function(){
  const area=document.querySelector('main .product-block-area');if(!area)return;
  area.classList.add('gb-mobile-product');
  const blocks=[...area.querySelectorAll(':scope > [data-gb-block]')];
  if(!blocks.length)return;
  const media=matchMedia('(max-width: 749px)');
  const find=id=>blocks.find(e=>e.dataset.gbBlock===id);
  function arrange(){
    if(!media.matches){blocks.forEach(el=>area.append(el));return;}
    const variant=blocks.find(e=>e.dataset.gbKind==='variant_picker');
    const buy=blocks.find(e=>e.dataset.gbKind==='buy_buttons');
    const offer=find('custom_liquid_ygzK8K');
    if(offer&&variant)variant.before(offer);
    if(variant&&buy)variant.after(buy);
    // Keep the long fit/shipping guidance below the native purchase controls.
    const help=find('gb_purchase_help');if(help&&buy)buy.after(help);
  }
  arrange();media.addEventListener('change',arrange);
})();
